<template>
	<vue-ladda
		v-bind="$attrs"
		:class="this.class"
		:disabled="disabled"
		:loading="loading"
		:type="type"
		data-size="s"
		data-style="zoom-in"
	>
		<AppIcon v-if="icon" :icon="icon" fixed-width />
		<slot />
	</vue-ladda>
</template>

<script>
	import VueLadda from 'vue-ladda/src/vue-ladda.vue';
	import AppIcon from './AppIcon';

	export default {
		name: 'AppButton',
		components: {
			VueLadda,
			AppIcon,
		},
		props: {
			class: {
				type: String,
				default: 'btn btn-primary',
			},
			icon: {
				type: String,
				default: null,
			},
			title: {
				type: String,
				default: null,
			},
			button: {
				type: String,
				default: 'border',
			},
			color: {
				type: String,
				default: 'primary',
			},
			loading: {
				type: Boolean,
				default: false,
			},
			type: {
				type: String,
				default: 'button',
			},
			disabled: {
				type: [Boolean, String],
				default: false,
			},
		},
	};
</script>
